import type { ReactNode } from "react";

interface FiltersPanelProps {
  children: ReactNode;
}

export const FiltersPanel = ({ children }: FiltersPanelProps) => {
  return (
    <div className="bg-background flex h-full min-h-0 flex-col rounded-lg border">
      <div className="min-h-0 flex-1 space-y-4 p-4">{children}</div>
    </div>
  );
};
